import { Update } from "@clockwise/design-system/icons";
import { fg_info } from "@clockwise/design-system/tokens";
import { AddLink, CalendarAddOn } from "@clockwise/icons";
import React from "react";

export const rescheduleOptionIcon = <Update fill={fg_info} className="cw-h-4 cw-w-4" />;
export const scheduleOptionIcon = <CalendarAddOn className="cw-text-brand cw-h-4 cw-w-4" />;
export const createLinkOptionIcon = <AddLink className="cw-text-busy cw-h-4 cw-w-4" />;
